angular.module('e360')
   .directive('searchInput', searchInputDirective);

var viewUrl = require('./view.html');

function searchInputDirective() {
   return {
      restrict: 'A',
      templateUrl: viewUrl,
      scope: {
         ngModel: '=',
         showHelp: '<'
      },
      link:searchInputLinkFn
   };
}

function searchInputLinkFn(scope, element, attrs) {
   element.find('input').attr('placeholder', attrs.placeholder || 'Search...');
   element.addClass('search');

   scope.$on('filterReset', function() {
      scope.ngModel = '';
   });

   scope.onChange = function() {
      scope.$emit('search', scope.ngModel);
   };
}
